import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { ManageReleaseFormType } from '@/types';

import { Button } from '@/components/ui/button';

interface ReleaseFormActionsProps {
  id: string | null;
  isLoading: boolean;
  isWarningModalOpen: boolean;
  onClose: () => void;
}

const ReleaseFormActions = ({
  id,
  isLoading,
  isWarningModalOpen,
  onClose,
}: ReleaseFormActionsProps) => {
  const { t } = useTranslation();
  const {
    formState: { isValid, isDirty, isSubmitting },
  } = useFormContext<ManageReleaseFormType>();

  const isSaveDisabled =
    !isValid || isLoading || isSubmitting || isWarningModalOpen || (!!id && !isDirty);

  return (
    <div className="flex justify-start gap-3">
      <Button type="button" onClick={onClose} disabled={isLoading}>
        {t('actions.cancel')}
      </Button>
      <Button variant="default" type="submit" disabled={isSaveDisabled}>
        {t('actions.save')}
      </Button>
    </div>
  );
};

export default ReleaseFormActions;
